import { type ISelectInputProps, SelectInput } from '@framework/form';
import type { ButtonProps } from 'antd';

export interface IElectoralListSelectInputProps {
  name: string;
  size?: ButtonProps['size'];
  style?: React.CSSProperties;
  options?: ISelectInputProps['options'];
}

/**
 * Input di selezione asincrona per le liste elettorali
 */
export function ElectoralListSelectInput(
  props: IElectoralListSelectInputProps,
) {
  const { name, size, options } = props;

  return (
    <SelectInput
      size={size}
      options={options}
      placeholder="Seleziona una lista elettorale..."
      name={name}
      showSearch
      style={{ minWidth: '100px', ...props.style }}
      optionFilterProp="label"
    />
  );
}
